(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biocharge-brochure"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-brochure-download]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    const status = link.closest('.bio-brochure').querySelector('[data-brochure-status]');
    link.setAttribute('aria-busy', 'true');
    status.textContent = status.dataset.loading;
    try {
      const response = await fetch(link.dataset.brochureUrl, { credentials: 'omit' });
      if (!response.ok) throw new Error('Download unavailable');
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const download = document.createElement('a');
      download.href = url;
      download.download = 'Bio_Charge_Company_Product_Brochure.pdf';
      document.body.append(download);
      download.click();
      download.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      status.textContent = status.dataset.done;
    } catch {
      status.textContent = status.dataset.fallback;
    } finally {
      link.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
